import React from 'react';
import Modal from 'components/UI/Modal';
import { alert } from 'util/alert';
import "./Modal.scss";
import ModalContent from "./ModalContent";
import { confirmable } from 'react-confirm';
import locale from './locale';
import addClassCTRL from 'controllers/class/addClass'
import editClassCTRL from 'controllers/class/editClass'
import getClassTeacherStudent from 'controllers/class/getClassTeacherStudent'
import {fetchClass} from 'containers/pages/Class/ducks'
import { connect } from 'react-redux';
import {fetchClassLesson} from 'containers/pages/ClassDetail/ducks'
import {browserHistory} from 'react-router'

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = (dispatch) => {
	return {
    fetchClass: (opts) => dispatch(fetchClass(opts)),
    fetchClassLesson: (classId, params) => dispatch(fetchClassLesson(classId, params)),
	};
};


class ModalBody extends React.Component {

  constructor(props){
    super(props)

		const INIT_FORM_DATA = {
			costAlertRange: 1,
			costRule: true,
			absentFlag: true,
			cancelFlag: false,
			billingMethod: {
				feeType: 0,
			}
		}

		this.state = {
			classData: INIT_FORM_DATA,
			disabledBtn: false
		}
  }

	componentDidMount(){
		if(this.props.id){
			getClassTeacherStudent(this.props.id, true)
			.then((res) => {
				let studentArr = []
				if(res.classStudentList.length >= 1){
          // studentArr = [{name: res.classStudentList[0].ssName, id: res.classStudentList[0].id}]
          studentArr = res.classStudentList.map((student)=>{
            return {
              name: student.ssName,
              id: student.id,
            }
          });
        }
				let teacherArr = []
				res.classTeacherList.map((item) => {
					teacherArr.push({name: item.stName, id: item.id})
				})

				let classData = {
					cName: res.classDetail.cName,
					feeType: res.classDetail.feeType,
					costAlertRange: res.classDetail.costAlertRange,
					costRule: true,
					cancelFlag: res.classDetail.cancelFlag == 1 ? true : false,
					absentFlag: res.classDetail.absentFlag == 1 ? true : false,
					student_id_list: studentArr,
					teacher_id_list: teacherArr,
					billingMethod: {
						feeType: res.classDetail.feeType,
						totalPrice: res.classDetail.totalPrice,
						unitPrice: res.classDetail.unitPrice,
						consumption_type: res.classDetail.consumption_type,
					}
				}
				this.setState({classData})
			})
		}

    if(this.props.studentInfo){
      console.log(this.props.studentInfo);
			let studentArr = [{name: this.props.studentInfo[0].name, id: this.props.studentInfo[0].id}]
			let classData = {
				student_id_list: studentArr,
				costAlertRange: 1,
				costRule: true,
				absentFlag: false,
				cancelFlag: true,
				billingMethod: {
					feeType: 0
				}
			}
			this.setState({classData})
		}
	}

	render() {
		let {
      show,
      proceed,
      dismiss,
      cancel,
			mode,
			pagination,
			pageState
    } = this.props;

    const schoolId = localStorage.getItem('schoolId')

		return (
      <Modal
        className='create-classone-modal'
        isShowingModal={show}

        onCloseModalClick={dismiss}
        fixedWidth={600}
        overlayColor="#000"

        hasHeader={true}
        headerTitle={ this.props.mode == 'create' ? __('Create Private Class', locale) : __('Edit Private Class', locale)}
        headerType="bold"
        footerType="grey"
        hasFooter={true}
        footerButtons={[
          {
            title: __('Complete', 'appwrapper'),
            className: `btn btn-primary pull-right`,
            onClick: ()=>{
							this.setState({disabledBtn: true})

              const validateResult = this.validate();

              if (!validateResult.ok) {
								this.setState({disabledBtn: false})
                return;
              }

							let arr = [];
							if(this.state.classData.teacher_id_list){
								this.state.classData.teacher_id_list.map((teacher) => {
									arr.push(teacher.id)
								})
							}

							let consumption_type;
							let feeType = this.state.classData.billingMethod.feeType ? this.state.classData.billingMethod.feeType : 1

							feeType == 1 ? consumption_type = 1 : consumption_type = 2

							let newFormData = {
								...this.state.classData,
								absentFlag: this.state.classData.absentFlag ? 1 : 0,
								cancelFlag: this.state.classData.cancelFlag ? 1 : 0,
								costRule: 1,
								cType: 1,
                // student_id_list: this.state.classData.student_id_list.length >= 1 ? [this.state.classData.student_id_list[0].id] : [],
                student_id_list: (this.state.classData.student_id_list || []).map((student)=>{
                  return student.id;
                }),
								teacher_id_list: arr,
								feeType: typeof(this.state.classData.billingMethod.feeType) !== 'undefined' ? this.state.classData.billingMethod.feeType : 1,
								consumption_type: this.state.classData.billingMethod.consumption_type ? this.state.classData.billingMethod.consumption_type : consumption_type,
								totalPrice: this.state.classData.billingMethod.totalPrice ? this.state.classData.billingMethod.totalPrice : undefined,
								unitPrice: this.state.classData.billingMethod.unitPrice ? this.state.classData.billingMethod.unitPrice : undefined
							}

							delete newFormData.billingMethod

              console.log("createClassOne: newFormData", newFormData);

              if(mode == 'create'){
								addClassCTRL(schoolId, newFormData)
								.then((res) => {
									localStorage.setItem('showClassOneOnboarding', 'false')

									if(res.result == 'success'){
										this.props.fetchClass({schoolId, type: '1on1', state: 'current', amount_per_page: 25, current_page_number: 1})
										if(this.props.studentInfo){
											browserHistory.push('/one_one')
										}
										this.props.proceed()
									}
								})
              } else if (mode == 'update'){
								editClassCTRL(this.props.id, newFormData)
								.then((res) => {
									if(res.result == 'success'){
										this.props.fetchClassLesson(this.props.id,{
											amount_per_page: pagination.itemsCountPerPage,
											current_page_number: pagination.activePage,
											after_today: pageState === 'current'? 1 : 0
										})
										this.props.proceed()
									}
								})
              }
            },
						isDisabled: ()=>{
							return this.state.disabledBtn
						}
          },
        ]}
      >
        <ModalContent
          {...this.props}
					classData={this.state.classData}
					onFormChange={(classData)=>{ this.setState({ classData })}}
          getValidationRef={(fn)=>{
            this.validate = fn;
          }}
        />
      </Modal>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(confirmable(ModalBody));



// WEBPACK FOOTER //
// ./src/template/Modals/CreateClassOne/ModalBody.js